import * as React from 'react';
import { Spinner } from "../../../../components/Spinner";

const helperStyles = require('../../../../components/BootstrapHelper.local.css');

interface Props
{
    isLoading: boolean;
    value: string;
}

export const Loadable = (props: Props & { children?: React.ReactNode }): JSX.Element => {
    return (
        props.isLoading
        ? <div className="form-control" style={{ pointerEvents: "none" }}>
            <Spinner />
            <span className={helperStyles.MarginLeft}>{props.value}</span>
        </div>
        : props.children as JSX.Element
    );
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/EditCreate/Loadable.tsx